<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="white",
      absolute,
      top
    )
    v-row.pb-10.pt-5.align-self-start(align="center", v-if="entity")
      v-col.py-0.text-right
        v-btn(color="white", @click="save()", :disabled="disabledSave") {{ $t('Common.save') }}

    v-row(v-if="!loading")
      v-col.py-0
        v-card.elevation-24.mb-5
          app-full-entity(v-if="!loading", :entity="endEntity")
            template(v-slot:Chart="props")
              chart-general(:slotProps="props", v-model="chartType", :config.sync="config",  v-bind="{ errors, loading }")
            template(v-slot:dataSets="props")
              data-sets(v-bind="{ ...props, errors }")
            template(v-slot:dimensions="props")
              app-entity-relation(v-bind="{...props}")
</template>


<style lang="sass">
.delete-button
  position: absolute
  right: 15px
</style>

<script>
import axios from 'axios'
import { GChart } from 'vue-google-charts'
import EntityMixin from '@/mixins'

import ChartGeneral from '@/components/Chart/General';

export default {
  mixins: [EntityMixin],
  name: 'chart-add',
  components: {
    GChart,
    ChartGeneral,
  },
  data: function () {
    return {
      loading: true,
      disabledSave: false,
      errors: {},
      chartType: null,
      config: {},
    }
  },
  computed: {
    instance: {
      get () {
        return this.$store.state.instance || {}
      },
      set (instance) {
        this.$store.commit('SET_INSTANCE', instance)
      }
    },
    entityName () {
      return 'Chart'
    },
    entity () {
      return this.$searchEntity(this.entityName, 'name', false)
    },
    endEntity() {
      const newEntity = _.cloneDeep(this.entity);
      let indexBS = newEntity.fields.findIndex(x => x.name === 'businessScope');
      if (indexBS != -1) newEntity.fields[indexBS].section = 'Chart';
      return newEntity;
    },
    uid () {
      return this.$route.params.item
    },
  },
  methods: {
    async save () {
      this.disabledSave = true
      var configJSON = JSON.stringify({ options: this.config, type: this.chartType });
      this.instance.config = configJSON;
      try {
        this.instance = (await axios.post('entity/graph', this.instance)).data
        this.$router.push({
          name: 'entities.index',
          params: { entity: this.entity.name }
        })
      } catch (error) {
        this.errors = error.response.data.errors
        this.$store.commit('SET_ERRORS', this.errors)
        this.$store.commit('SET_ERROR_MODAL', true)
      } finally {
        this.disabledSave = false;
      }
    },

    /* TODO: docs */
    async load () {
      if (this.uid) {
        try {
          this.instance.uid = this.uid
          this.instance = {...this.instance, ...(await axios.get(`${this.entity.name}/${this.uid}`, {
            params: {
              load: ['DataSets','DataSets.Criterias','Dimensions','User']
            }
          })).data}
          this.instance.entityState = ENV.ENTITY.STATE.MODIFIED

          var chartConfig = JSON.parse(this.instance.config)
          this.chartType = chartConfig['type']
          this.config = chartConfig['options']

          this.$store.commit('SET_INSTANCE', this.instance)
          this.$store.commit('SET_CRITERIA_ENTITY_NAME', this.instance.entity)

        } catch (error) {
          console.error(error)
        }
      }
      else {
        const newInst = {
          entityState: 4,
          _Entity: this.entityName,
          user: this.$store.state.user.user,
          criterias: [],
          dimensions: [],
        };
        this.instance = newInst;
      }
      this.loading = false;
    },
  },
  async created () {
    this.$store.commit('SET_INSTANCE', null);
  },
  async mounted () {
    await this.load()
  }
}
</script>
